module.exports = __webpack_public_path__ + "media/images/teams/logo__9-2863fb76a70df06e593e72bc3fee28ba.svg";